import React from "react";
import "../styles/Header.css";

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  return (
    <>
      <header className="wmnds-header">
        <div className="wmnds-container wmnds-grid wmnds-grid--align-center wmnds-grid--justify-between">
          <div className="wmnds-header__vertical-align wmnds-col-auto">
            <a
              className="wmnds-header__logo-link"
              href="//tfwm.org.uk"
              title="Transport for West Midlands Home"
            >
              <img
                className="wmnds-header__logo"
                alt="Transport for West Midlands logo"
                src="https://unpkg.com/wmn-design-system@2.2.0/build/img/logo.svg"
              />
            </a>
          </div>
          <h1
            className="wmnds-header__title h1 wmnds-col-1 wmnds-col-sm-auto"
            id="formClicked"
          >
            Swift Top-up Locations
          </h1>
        </div>
      </header>
      <nav
        aria-label="Breadcrumb"
        className="wmnds-breadcrumb wmnds-container"
      >
        <ol className="wmnds-breadcrumb__list">
          <li className="wmnds-breadcrumb__list-item">
            <a href="//tfwm.org.uk" className="wmnds-breadcrumb__link">
              Home
            </a>
          </li>
          <li className="wmnds-breadcrumb__list-item">
            <a
              href="/"
              className="wmnds-breadcrumb__link wmnds-breadcrumb__link--current"
              aria-current="page"
            >
              Find a ticket machine
            </a>
          </li>
        </ol>
      </nav>
    </>
  );
};

export default Header;
